// Stamps each row with the draft section it shows under. A row whose section no longer exists (removed,
// or left over from an earlier round) falls back to where it started.
export function assignCommentarySections(categoryGroups, draftSections) {
    const sectionIds = new Set(draftSections.map((section) => section.id))
    return (categoryGroups ?? [])
        .flatMap((group) => group.schedules)
        .map((row) => ({ ...row, sectionId: resolveSectionId(row, sectionIds) }))
}

// Draft order, excluded rows left out. Empty built-in sections are hidden; custom ones always show.
export function buildCommentaryPageSections(rows, draftSections) {
    const includedRows = rows.filter((row) => !row.excludedFromCycle)
    return draftSections
        .map((section) => ({ ...section, schedules: includedRows.filter((row) => row.sectionId === section.id) }))
        .filter((section) => section.custom || section.schedules.length > 0)
}

function resolveSectionId(row, sectionIds) {
    return [row.category, row.originalCategory, row.groupCategory].find((id) => sectionIds.has(id)) ?? null
}
